"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateInvoice = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-restricted-globals */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
const react_1 = require("react");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const de_ui_1 = require("@delab-team/de-ui");
const react_i18next_1 = require("react-i18next");
const buyApi_1 = require("../../../../logic/buyApi");
const tonapi_1 = require("../../../../logic/tonapi");
const smlAddr_1 = require("../../../../helpers/smlAddr");
const svg_selector_1 = require("../../../../assets/svg-selector");
const invoice_module_css_1 = __importDefault(require("./invoice.module.css"));
const titleTgStyles = { color: 'var(--tg-theme-text-color)' };
const InputStyle = { color: 'var(--tg-theme-text-color)' };
const spanTgStyles = { color: 'var(--tg-theme-accent-text-color)' };
const CreateInvoice = (props) => {
    const buyApi = new buyApi_1.BuyApi();
    const TgObj = sdk_1.default;
    const tonApi = new tonapi_1.TonApi();
    const { t } = (0, react_i18next_1.useTranslation)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    console.log('isLoading', isLoading);
    (0, react_1.useEffect)(() => {
        const getHistory = async () => {
            try {
                const res = await buyApi.getInvoiceHistory('/api/invoice/all', {
                    telegramId: String(TgObj.initDataUnsafe.user?.id),
                    limit: 50
                });
                console.log('INVOICE HISTORY RES', res);
            }
            catch (err) {
                console.log(err);
            }
        };
        getHistory();
    }, []);
    async function buyMakeToCompl() {
        if (props.sendData.token === 'TON') {
            try {
                console.log('START CREATE INVOICE  TON');
                setIsLoading(true);
                TgObj.MainButton.showProgress();
                if (!props.sendData.customerEmail
                    || !props.sendData.cardNumber
                    || !TgObj.initDataUnsafe.user?.id
                    || !TgObj.initDataUnsafe.user?.id
                    || !TgObj.initDataUnsafe.user?.username
                    || !props.addressUser) {
                    TgObj.MainButton.hideProgress();
                    setIsLoading(false);
                    return;
                }
                const priceTokenRub = await tonApi.getTokenPrice(props.sendData.tokenAddress, 'rub');
                if (!priceTokenRub
                    || !priceTokenRub?.rates[props.sendData.tokenAddress]?.prices.RUB
                    || !priceTokenRub.rates) {
                    TgObj.MainButton.hideProgress();
                    setIsLoading(false);
                    return;
                }
                const requestBody = {
                    amount: priceTokenRub.rates[props.sendData.tokenAddress].prices.RUB * Number(props.sendData.amount),
                    cardNumber: props.sendData.cardNumber,
                    toWallet: props.addressUser,
                    customerEmail: props.sendData.customerEmail,
                    customerContact: `https://t.me/${TgObj.initDataUnsafe.user.username}`
                };
                console.log('requestBody', requestBody);
                const res = await buyApi.BuyTon(requestBody);
                if (res) {
                    props.setApiResponce(res);
                    TgObj.MainButton.hideProgress();
                    props.setPosition(3);
                }
                if (!res) {
                    props.setApiResponce(undefined);
                    TgObj.MainButton.hideProgress();
                    props.setPosition(3);
                }
            }
            catch (err) {
                console.error(err);
            }
            finally {
                setIsLoading(false);
                TgObj.MainButton.hideProgress();
            }
        }
        else if (props.sendData.token !== 'TON') {
            try {
                console.log('START CREATE INVOICE');
                setIsLoading(true);
                TgObj.MainButton.showProgress();
                if (!TgObj.initDataUnsafe.user?.id
                    || !TgObj.initDataUnsafe.user?.id
                    || !TgObj.initDataUnsafe.user?.username
                    || !props.addressUser) {
                    TgObj.MainButton.hideProgress();
                    setIsLoading(false);
                    return;
                }
                const priceTokenRub = await tonApi.getTokenPrice(props.sendData.tokenAddress, 'rub');
                if (!priceTokenRub
                    || !priceTokenRub?.rates[props.sendData.tokenAddress]?.prices.RUB
                    || !priceTokenRub.rates) {
                    TgObj.MainButton.hideProgress();
                    setIsLoading(false);
                    return;
                }
                const requestBody = {
                    amount: priceTokenRub.rates[props.sendData.tokenAddress].prices.RUB * Number(props.sendData.amount),
                    telegramId: String(TgObj.initDataUnsafe.user?.id),
                    telegramUsername: TgObj.initDataUnsafe.user?.username,
                    walletAddress: props.addressUser,
                    coinType: props.sendData.token
                };
                console.log('requestBody', requestBody);
                const res = await buyApi.post('/api/invoice', requestBody);
                if (res) {
                    props.setApiResponce(res);
                    TgObj.MainButton.hideProgress();
                    props.setPosition(3);
                }
                if (!res) {
                    props.setApiResponce(undefined);
                    TgObj.MainButton.hideProgress();
                    props.setPosition(3);
                }
            }
            catch (err) {
                console.error(err);
            }
            finally {
                setIsLoading(false);
                TgObj.MainButton.hideProgress();
            }
        }
    }
    (0, react_1.useEffect)(() => {
        if (props.position !== 2 || !props.sendData.amount || !props.sendData.token)
            return;
        TgObj.MainButton.show();
        if (props.position !== 2 || !props.sendData.amount || !props.sendData.token) {
            TgObj.MainButton.disable();
            TgObj.MainButton.text = t('buy-modal.write-correct-amount');
            TgObj.MainButton.color = '#9a9c9a';
        }
        else {
            TgObj.MainButton.enable();
            TgObj.MainButton.color = '#007AFF';
            TgObj.MainButton.text = t('buy-modal.create-invoice');
        }
        const handleBtnClick = () => {
            buyMakeToCompl();
            TgObj.MainButton.offClick(handleBtnClick);
        };
        TgObj.MainButton.onClick(handleBtnClick);
        return () => {
            TgObj.MainButton.offClick(handleBtnClick);
        };
    }, [props.position === 2, props.sendData.token, props.sendData]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: invoice_module_css_1.default.container, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: invoice_module_css_1.default.modalTitle, children: t('send.checkout') }), (0, jsx_runtime_1.jsxs)("div", { className: invoice_module_css_1.default.top, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: invoice_module_css_1.default.youSend, children: t('trans-detail.you-buy') }), (0, jsx_runtime_1.jsxs)("div", { className: invoice_module_css_1.default.topAmountWrapper, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: invoice_module_css_1.default.topAmount, children: props.sendData.amount }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: invoice_module_css_1.default.topAmountToken, children: props.sendData.token })] }), props.rubAmount && ((0, jsx_runtime_1.jsxs)(de_ui_1.Text, { className: invoice_module_css_1.default.topAmountUsd, children: ["~ ", parseFloat(Number(props.rubAmount).toString()).toLocaleString('ru', {
                                style: 'currency',
                                currency: 'RUB'
                            })] }))] }), (0, jsx_runtime_1.jsxs)("div", { className: invoice_module_css_1.default.info, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: invoice_module_css_1.default.detailsHeader, children: t('trans-detail.header') }), (0, jsx_runtime_1.jsx)("div", { className: invoice_module_css_1.default.dottedLine, children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "dotted-line" }) }), (0, jsx_runtime_1.jsxs)("div", { className: invoice_module_css_1.default.infoItem, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: invoice_module_css_1.default.infoItemLeft, children: t('trans-detail.address') }), (0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: invoice_module_css_1.default.infoItemRight, children: (0, smlAddr_1.smlAddrCheckout)(props?.addressUser) })] })] })] }));
};
exports.CreateInvoice = CreateInvoice;
